// Delivery Estimate widget
export var DEFAULT_DELIVERY_ESTIMATE_ERROR_MESSAGE = "Sorry, something went wrong. Please re-enter your postcode";